import Form from "../../components/Form/Form";
import MapEmbed from "../../components/Map/map";
function Contact() {
  return (
    <>
      <article className="contact-presentation">
        <section>
          <h1>Entrer en contact</h1>
          <p>Pour toutes vos demandes d'installation, contactez Lemaire Plomberie des Weppes aujourd'hui.</p>
        </section>
        <section>
          <div>
            <h4>
              <i className="fa-solid fa-envelope"></i>Email
            </h4>
            <p>LPweppes@outlook.fr</p>
          </div>
          <div>
            <h4>
              <i className="fa-solid fa-phone"></i>Téléphone
            </h4>
            <p>06 68 86 07 78</p>
          </div>
          <div>
            <h4>
              <i className="fa-solid fa-location-dot"></i>Siége social
            </h4>
            <p>59211 Santes</p>
          </div>
        </section>
      </article>
      <div className="position">
        <MapEmbed />
      </div>

      <article className="contact-form">
        <div>
          <h1>Nous contacter par mail</h1>
          <p>N'hésitez pas à nous contacter pour toutes questions éventuelles.</p>
        </div>
        <Form />
      </article>
    </>
  );
}

export default Contact;
